import React, { useState } from 'react';
import Window from '../window-system/Window';
import { BattleResult } from '../../types';
import './BattleResultModal.css';

interface BattleResultModalProps {
  result: BattleResult;
  characterId: string;
  onClose: () => void;
}

const BattleResultModal: React.FC<BattleResultModalProps> = ({ 
  result, 
  characterId,
  onClose 
}) => {
  const [position, setPosition] = useState({ x: window.innerWidth / 2 - 300, y: 100 });
  const [size, setSize] = useState({ width: 600, height: 500 });
  const [showFullLog, setShowFullLog] = useState(false);
  
  const isWinner = result.winner.id === characterId;
  
  return (
    <Window
      id="battle-result-modal"
      title="Результат боя"
      position={position}
      size={size}
      minWidth={500}
      minHeight={400}
      onClose={onClose}
      onPositionChange={setPosition}
      onSizeChange={setSize}
      zIndex={2000}
    >
      <div className="battle-result-content">
        <div className={`battle-result-header ${isWinner ? 'victory' : 'defeat'}`}>
          <h2>{isWinner ? 'ПОБЕДА!' : 'ПОРАЖЕНИЕ'}</h2>
          <div className="battle-result-summary">
            <p className="winner-text">
              Победитель: <strong>{result.winner.nickname}</strong>
            </p>
            <p className="loser-text">
              Проигравший: <strong>{result.loser.nickname}</strong>
            </p>
            {isWinner && (
              <p className="experience-text">
                Получено опыта: <strong>+{result.experienceGained}</strong>
              </p>
            )}
          </div>
        </div>
        
        <div className="battle-log-section">
          <div className="battle-log-header">
            <h3>Лог боя</h3>
            <button 
              className="toggle-log-btn"
              onClick={() => setShowFullLog(!showFullLog)}
            >
              {showFullLog ? 'Свернуть' : 'Развернуть'}
            </button>
          </div>
          
          <div className={`battle-log ${showFullLog ? 'expanded' : 'collapsed'}`}>
            {(result.battleLog || result.combatLog || []).map((line, index) => (
              <div 
                key={index} 
                className={`log-line ${line.includes('Раунд') ? 'round-header' : ''}`}
              >
                {line}
              </div>
            ))}
          </div>
        </div>
        
        <div className="battle-result-footer">
          <button className="btn-close-result" onClick={onClose}>
            Закрыть
          </button>
        </div>
      </div>
    </Window>
  );
};

export default BattleResultModal;
